import { FC } from 'react';
import { ServicesOperatories } from '../../../PractitionerSchedule';
import { Option } from '../../../../../../MainSection/PractitionerProfile/MultipleSelect/MultipleSelect';

interface ServiceByOpeartoriesProps {
  service: Option;
  operatories: Option[];
  value: ServicesOperatories[];
  onChange: (...event: any[]) => void;
}

const ServiceByOpeartories: FC<ServiceByOpeartoriesProps> = ({
  service,
  operatories,
  value,
  onChange,
}) => {
  const serviceOperatories = value.find(
    (item) => item.serviceId === service.value
  )!;

  const isChecked = (operatoryId: string) => {
    return serviceOperatories?.operatoryIds.includes(operatoryId);
  };

  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    operatory: Option
  ) => {
    const isOperatoryChecked = e.target.checked;

    const currentServiceOperatoryIds = serviceOperatories?.operatoryIds ?? [];

    if (isOperatoryChecked) {
      const updatedServiceOperatoryIds = [
        ...currentServiceOperatoryIds,
        operatory.value,
      ];

      const updatedValue = value.map((item) =>
        item.serviceId === service.value
          ? { ...item, operatoryIds: updatedServiceOperatoryIds }
          : item
      );

      onChange(updatedValue);
      return;
    }

    const updatedServiceOperatoryIds = currentServiceOperatoryIds.filter(
      (id) => id !== operatory.value
    );

    const updatedValue = value.map((item) =>
      item.serviceId === service.value
        ? { ...item, operatoryIds: updatedServiceOperatoryIds }
        : item
    );

    onChange(updatedValue);
  };

  return (
    <>
      <li className="flex items-center gap-x-1.6">
        <label
          className="text-14 leading-[2.1rem] font-bold"
          htmlFor={service.value}
        >
          {service.label}
        </label>
      </li>
      <ul className="pl-3.2 flex flex-col gap-y-1.6 py-1.6">
        {operatories.map((operatory) => (
          <li className="flex items-center gap-x-1.6" key={operatory.value}>
            <input
              id={`${operatory.value}-${service.value}`}
              className="w-1.8 h-1.8"
              type="checkbox"
              value={operatory.value}
              checked={isChecked(operatory.value)}
              onChange={(e) => handleOnChange(e, operatory)}
            />
            <label
              className="text-14 leading-[2.1rem]"
              htmlFor={`${operatory.value}-${service.value}`}
            >
              {operatory.label}
            </label>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ServiceByOpeartories;
